// TODO: these constands are starting to diverge from being about search / list pages
//  We should figure out a new name/structure

export const Search = {
    // This is a client version of the SearchFacetType enum
    FacetType: {
        NONE: { key: "none", value: 0 },
        JOB_TYPE: { key: "job_type", value: 1 },
        JOB_LOCATION: { key: "location", value: 2 },
        JOB_CATEGORY: { key: "category", value: 3 },
        JOB_POSITION: { key: "position", value: 5 },
        JOB_SEARCH_SCOPE: { key: "scope", value: 6 },
        JOB_CANDIDATE_STATUS: { key: "candidate_status", value: 7 },
        JOB_CANDIDATE_PHASE: { key: "status", value: 8 },
    },
    MessageFilter: {
        SYSTEM_ALL_MESSAGES: 0,
        MY_ALL_MESSAGES: 100,
        MY_UNREAD_MESSAGES: 101,
    },
    // JobCandidatePhase enum
    JobCandidatePhase: {
        UNKNOWN: 0,
        REVIEW: 1,
        CONSIDERATION: 2,
        ELIMINATED: 3,
        HIRED: 4,
    },
    JobCandidateStatus: {
        NEW: 10,
        QUALIFYING: 20,
        REVIEW: 25,
        SUBMITTED: 30,
        INTERVIEWING: 40,
        OFFERED: 45,
        REJECTED: 50,
        HIRED: 60,
    },
    JobSearchScope: {
        ALL: 0,
        RECOMMENDED: 1,
        MY: 2,
    },
};

export const SortKeys = {
    // JobSearchOrderBy enum
    Job: {
        CREATE_TIMESTAMP: 0,
        JOB: 1,
        LOCATION: 2,
        STATUS: 3,
        TEAM_NAME: 4,
        QUANTITY_MINUS_HIRED_JOB_CANDIDATE_COUNT: 5,
        RELEVANCE: 15,
        PRIORITY: 16,
        CATEGORY: 17,
        TYPE: 18,
        REFERRAL_REWARD: 21,
    },
    JobCandidate: {
        CREATE_TIMESTAMP: 0,
        JOBCANDIDATE_USER_DISPLAYNAME: 1,
        JOBCANDIDATE_STATUS: 2,
        RELEVANCE: 3,
        JOB_NAME: 4,
    },
    Friends: {
        CREATE_TIMESTAMP: 0,
        DISPLAY_NAME: 1,
        RELEVANCE: 2,
    },
};
